import { render, staticRenderFns } from "./TabelaSimpro.vue?vue&type=template&id=1d719d42&"
import script from "./TabelaSimpro.vue?vue&type=script&lang=js&"
export * from "./TabelaSimpro.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports